import * as surveyActions from './survey'

export default surveyActions
